import React from 'react';

const style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
};

const Preloader = () => {
  return (
    <div style={style}>Loading...</div>
  );
}

export default Preloader;